import type { Ilink } from '~ui/types/components/Link';
import type { ISbColorField } from '~ui/types';
import type { EHideOnType } from '~ui/types/enums/ComponentStyle';

export interface IBreadcrumbsConfig {
    _uid: string;
    component: string;
    breadcrumbs: IBreadcrumbsItem[];
    sectionBackground: ISbColorField;
    homeIconDisplay: EHomeIconDisplayType;
    hideOn: EHideOnType;
    align: string;
    _editable: string;
}

interface IBreadcrumbsItem {
    Text: string;
    Link: Ilink;
    _uid: string;
    component: string;
    _editable: string;
}

export enum EHomeIconDisplayType {
    Always,
    OnlyMobile,
    OnlyDesktop,
    Never,
}
